import Layout from '../components/Layout';
import { Link, useNavigate } from 'react-router-dom';
import { useState } from 'react';
import { useAuth } from '../context/AuthContext';
import { toast } from '../hooks/use-toast';
import { Building2, ArrowRight } from 'lucide-react';

export default function PartnerLoginPage() {
  const [form, setForm] = useState({ identifier: '', password: '' });
  const [busy, setBusy] = useState(false);
  const { login } = useAuth();
  const navigate = useNavigate();

  const submit = async (e) => {
    e.preventDefault();
    setBusy(true);
    try {
      const u = await login({ identifier: form.identifier, password: form.password, role: 'partner' });
      toast({ title: `Welcome back, ${u.name}!` });
      navigate('/partner/dashboard');
    } catch (err) {
      toast({ title: 'Login failed', description: err.response?.data?.detail || 'Invalid credentials.' });
    } finally { setBusy(false); }
  };

  return (
    <Layout>
      <section className="py-16">
        <div className="max-w-md mx-auto px-6">
          <div className="card-soft p-8">
            <div className="w-12 h-12 rounded-xl bg-navy text-white flex items-center justify-center mb-5"><Building2 size={20} /></div>
            <h1 className="h-display text-3xl">Partner login</h1>
            <p className="text-sm text-neutral-500 mt-1">Access your partner console.</p>

            <form onSubmit={submit} className="mt-6 space-y-4">
              <div><label className="text-xs font-medium">Phone or Email</label><input value={form.identifier} onChange={(e) => setForm({ ...form, identifier: e.target.value })} className="mt-1 w-full px-3 py-2.5 rounded-lg border border-black/15 focus:ring-2 focus:ring-navy/30 focus:outline-none" /></div>
              <div><label className="text-xs font-medium">Password</label><input type="password" value={form.password} onChange={(e) => setForm({ ...form, password: e.target.value })} className="mt-1 w-full px-3 py-2.5 rounded-lg border border-black/15 focus:ring-2 focus:ring-navy/30 focus:outline-none" /></div>
              <button disabled={busy} type="submit" className="btn-primary w-full justify-center disabled:opacity-60">{busy ? 'Logging in...' : 'Login'} <ArrowRight size={16} /></button>
            </form>

            <p className="mt-6 text-sm text-center text-neutral-600">Not a partner yet? <Link to="/partner/signup" className="text-navy font-semibold">Register</Link></p>
            <p className="mt-2 text-xs text-center text-neutral-500">Customer? <Link to="/login" className="underline">Login here</Link></p>
          </div>
        </div>
      </section>
    </Layout>
  );
}
